import request from './request';

export function opinion(type, data) {
    return request('post', `/apiv2/opinion/${type}`, data);
}

export function opinions(data) {
    return request('get', `/apiv2/opinions/`, data);
}

export function deleteOpinion(id) {
    return request('delete', `/apiv2/opinion/${id}`, {});
}

export function editOpinion(id, data) {
    return request('put', `/apiv2/opinion/${id}`, data);
}